import { useEffect } from 'react';
import { getCompanyImage } from '../../../common/styles/Images';
import { getDomainValueForCode, getFlexColDomainValueForCode, isEmpty, formatDesignationDisplay } from '../../../library/Core/SmartFunctions';
import { Tooltip } from 'bootstrap';
import { getFieldOfStudyName } from '../alumni-profile/service/student-profile-view.service';

const RecruiterCardWorking = ({ alumni, state }: { alumni: any;  state: any }) => {
    console.log(alumni, " alumni ")

    return (
        <div key={alumni.uuid} className="alumni_univarsity_details working">
            <div className="alumni_univarsity_details_inner_cover">
            <div className="alumni_univarsity_logo">
                    {
                        alumni?.workingStatusCode === 'SELF_EMPLOYED_AND_FREELANCING' 
                            ? (() => {
                                const flexCol = getFlexColDomainValueForCode(alumni?.jobRoleCode, 'FREELANCING_JOB_ROLE_CODE', state);
                                console.log("flexCol",flexCol)
                                const current_logo = getCompanyImage(isEmpty(flexCol) ? '' : JSON.parse(flexCol).img);
                                return <img src={current_logo} alt="Freelance Logo" />;
                            })()
                            : (
                                <img src={getCompanyImage(alumni.jobCompanyImage)} alt="Company Logo" />
                            )
                    }
                </div>
                <div className="alumni_univarsity_brife">
                    <div className="alumni_education">
                        <div className="row g-2">
                            <div className="col">{(alumni?.workingStatusCode !== 'SELF_EMPLOYED_AND_FREELANCING') ? 'Working as' : 'Credited as'}</div>
                        </div>
                    </div>
                    <div className="alumni_univarsity_name">
                        <span>
                        {
                        alumni?.workingStatusCode === 'TEACHING_AND_RESEARCH'
                            ? (alumni?.workingInstituteId
                                ? getDomainValueForCode(alumni?.workingInstituteId, 'INSTITUTE_DOMAIN', state)
                                : alumni?.workingInstituteName)
                            : (alumni?.jobCompanyId
                                ? (getDomainValueForCode(alumni?.jobCompanyId, 'COMPANY_CODE', state) === alumni?.jobCompanyId
                                    ? alumni?.companyName
                                    : getDomainValueForCode(alumni?.jobCompanyId, 'COMPANY_CODE', state))
                                : alumni?.companyName)
                        }
                        </span>
                        {alumni?.jobCompanyPrestigious == 1 && (
                            <i className="ms-1 position-static bg-transparent">
                                <img src={`${process.env.REACT_APP_IMAGE_BASEPATH}/subtraction.svg`} />
                            </i>
                        )}
                    </div>
                    {alumni?.designation && (
                        <div className="alumni_univarsity_subject">
                            <i className="icon-brifecase"></i>
                            <span>{formatDesignationDisplay(alumni.designation, state, { workingStatusCode: alumni?.workingStatusCode })}</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RecruiterCardWorking;
